import Box from "../../../shared/box/Box";
import Button from "../../../shared/button";
import { useGetOutlookCredentialsQuery, useOutlookLogoutMutation } from "../../../store/google-reservations/googleReservationsApi";
import { useGetOutlookAuthUrlQuery } from "../../../store/reservations/reservationsApi";

const Settings = () => {
  const { data: outlookAuthUrl } = useGetOutlookAuthUrlQuery({});
  const { data: outlookCredentials, isLoading } =
    useGetOutlookCredentialsQuery();

	const [logoutOutlook] = useOutlookLogoutMutation()

  const handleOutlookAuth = () => {
    window.location.assign(outlookAuthUrl.authUrl);
  };
  const handleOutlookLogout = async () => {
	try{
		await logoutOutlook().unwrap();
		localStorage.removeItem('googleAccessToken');
		localStorage.removeItem('googleRefreshToken')
	} catch (e) {
		console.log({e})
	}
  };

  return (
    <div>
      <h4 className="page-title">Settings</h4>
      <div className="flex flex-wrap my-8 -mx-2">
        <div className="w-full md:w-6/12 px-2">
          <Box title="Outlook Login">
            {isLoading ? (
              <p className="text-sm">Loading...</p>
            ) : outlookCredentials?.accessToken ? (
				<>
             		<p className="mb-2"> You are already logged in </p>
					 <Button
						type="button"
						label={"Logout from outlook"}
						onClickButton={handleOutlookLogout}
					/>
				</>
            ) : (
              <Button
                type="button"
                label={"Login"}
                onClickButton={handleOutlookAuth}
              />
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Settings;
